// tslint:disable
import { Component, Injector } from "@angular/core";

import { CMFormComponent } from "../../@cmcore/component/cmform/cmform.component";

import {
  CMFormGlobaisComponent,
  CMFormModalComponent,
  CMGridEditConfig,
  CMInputConfig,
  CMGridEditConfigColumn,
  CMGridEditConfigMore,
} from "../../@cmcore/component";
import {
    NFeConsignacaoBrowseComponent,
} from "../index";
@Component({
  selector: "nfe-consignacao-relatorios",
  templateUrl: "nfe-consignacao-relatorios.component.html",
  styleUrls: ["nfe-consignacao-relatorios.component.scss"],
})
export class NFeConsignacaoRelatoriosComponent extends CMFormComponent {
  _owner: NFeConsignacaoBrowseComponent = undefined;

  get owner() {
    return this._owner;
  }

  private static relatoriosCustomizados: any = [];

  static addRelatorioCustomizado(item: any){
    NFeConsignacaoRelatoriosComponent.relatoriosCustomizados.push(item);
  }

  static getRelatorioCustomizados(){
    return NFeConsignacaoRelatoriosComponent.relatoriosCustomizados;
  }

  teste = 0;

  dados = {
    tiporelatorio: "NFeConsignacaoPadrao",
  };

  config = {
    tiporelatorio: new CMInputConfig({
                                    form: this,
                                    values: [
                                      {value: "NFeConsignacaoPadrao", text: "NFe Consignação Padrão"},
                                    ],
                                  }),
  };

  Imprimir(){
    
    if (this.dados.tiporelatorio === "NFeConsignacaoPadrao"){
        let data = { id: this.owner.grid.fieldByName(this.owner.fieldNameId()) };
        console.log(data);
        data = this.owner.getDataPrint(data);
        this.showRelat(
          "/Print",
          data,
          "nfeconsignacao"
        );
    }
    else{
      let data = { 
        id: this.owner.grid.fieldByName(this.owner.fieldNameId()),
        idrelatorio: this.dados.tiporelatorio
      };
      console.log(data);
      data = this.owner.getDataPrint(data);
      this.showRelat(
        "/ImpressaoNFeConsignacaoCustomizado",
        data,
        "nfeconsignacao"
      );
      
    }
  }

  podeCadastrarProduto: boolean = false;
  set owner(value) {
    this._owner = value;
  }

  constructor(_injector: Injector) {
    super(_injector);
    console.log('construtor');
    this.config.tiporelatorio.values.push.apply(this.config.tiporelatorio.values, NFeConsignacaoRelatoriosComponent.relatoriosCustomizados)
  }


  close(formName) {
    if (this.owner) this.owner.beforeComponent = undefined;
    CMFormModalComponent.close(formName);
  }
}
